import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-65BM4G6ZB7";

/**
 * Fires a GA4 page_view on every route change in this SPA.
 * Initial page_view is suppressed in index.html (send_page_view: false)
 * so we own pageview firing here — guarantees one event per route.
 */
export default function GAListener() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location.pathname, location.search]);

  return null;
}

/**
 * Helper to fire custom events from anywhere in the app.
 * Usage: trackEvent('buy_click', { product: 'playbook', value: 29 });
 */
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, { ...params, send_to: GA_ID });
}
